'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogHeaderImage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var setImageOffset = function setImageOffset(_ref) {
  var offsetBottom = _ref.offsetBottom,
      offsetTop = _ref.offsetTop;

  return {
    marginBottom: offsetBottom,
    marginTop: offsetTop * -1
  };
};

function UIDialogHeaderImage(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      offsetBottom = _ref2.offsetBottom,
      offsetTop = _ref2.offsetTop,
      style = _ref2.style,
      rest = _objectWithoutProperties(_ref2, ['children', 'className', 'offsetBottom', 'offsetTop', 'style']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classNames2.default)('private-modal__header-image', className),
      style: _extends({}, setImageOffset({ offsetBottom: offsetBottom, offsetTop: offsetTop }), style)
    }),
    children
  );
}

UIDialogHeaderImage.propTypes = {
  children: _react.PropTypes.node,
  offsetBottom: _react.PropTypes.number,
  offsetTop: _react.PropTypes.number
};

UIDialogHeaderImage.displayName = 'UIDialogHeaderImage';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dialog/UIDialogHeaderImage.js
// module id = 347
// module chunks = 3 4 5